import { render } from "./EditEaters.vue?vue&type=template&id=477e9402&scoped=true"
import script from "./EditEaters.vue?vue&type=script&lang=js"
export * from "./EditEaters.vue?vue&type=script&lang=js"

import "./EditEaters.vue?vue&type=style&index=0&id=477e9402&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477e9402"]])

export default __exports__